import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Checkbox from '#components/a/form/Checkbox'

export class CheckboxFilterDialog extends Component {
  checkForCheckedOptions = option => {
    let isChecked = false
    for (let index = 0; index < this.props.filterRules.length; index++) {
      const rules = this.props.filterRules[index]
      if (rules.rule === option) {
        isChecked = true
        break
      }
    }
    return isChecked
  }

  render() {
    const {checkboxOptions, type, toggleFilterRule} = this.props
    return (
      <div className="checkbox__wrapper">
        {checkboxOptions.map(o => (
          <Checkbox
            key={o}
            labelText={o}
            onChangeHandle={() => toggleFilterRule({rule: o, type})}
            checked={this.checkForCheckedOptions(o)}
          />
        ))}
      </div>
    )
  }
}

CheckboxFilterDialog.propTypes = {
  checkboxOptions: PropTypes.array.isRequired,
  toggleFilterRule: PropTypes.func,
  filterRules: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
}

export default CheckboxFilterDialog
